import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-general-content-state',
  templateUrl: './general-content-state.component.html',
  styleUrls: ['./general-content-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralContentStateComponent {
  @Input() textAlign = 'inherit';
}
